export const SECTION_BLOCK_NAME = 'Section'
export const COLUMN_BLOCK_NAME = 'Column'
